// rolePermissionAction.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import authServiceApiInstance from '../../../../config/apiConfig';
import { RolePermission } from './rolePermissionType';

export const createRolePermission = createAsyncThunk(
    'rolePermissions/create',
    async (rolePermissionData: { RoleId: number; PermissionKey: string; PermissionValues: string[]; }, { rejectWithValue }) => {
        try {
            if (!Array.isArray(rolePermissionData.PermissionValues)) {
                return rejectWithValue('PermissionValues must be an array');
            }
            const response = await authServiceApiInstance.post(`/rolepermissions`, rolePermissionData);
            return response.data; // Assuming the response contains the created role permission data
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create role permission');
        }
    }
);

// Update Role Permission
export const updateRolePermission = createAsyncThunk(
    'rolePermissions/update',
    async (rolePermissionData: { RolePermissionId: number; PermissionKey: string; PermissionValues: string[] }, { rejectWithValue }) => {
        try {
            if (!Array.isArray(rolePermissionData.PermissionValues)) {
                return rejectWithValue('PermissionValues must be an array');
            }
            const response = await authServiceApiInstance.put(`/rolepermissions/${rolePermissionData.RolePermissionId}`, rolePermissionData);
            return response.data; // Assuming the response contains the updated role permission data
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update role permission');
        }
    }
);

export const deleteRolePermission = createAsyncThunk(
    'rolePermissions/delete',
    async (rolePermissionId: number, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.delete(`/rolepermissions/${rolePermissionId}`);
            return response.data; // Assuming the response contains the result of the deletion
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete role permission');
        }
    }
);

export const fetchRolePermissionsByRoleId = createAsyncThunk(
    'rolePermissions/fetchByRoleId',
    async (roleId: number, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.get(`/rolepermissions/${roleId}`);
            return response.data; // Assuming the response contains the list of role permissions
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch role permissions');
        }
    }
);
// Fetch User Menu Permissions
export const getUserMenuPermissions = createAsyncThunk(
    'rolePermissions/getUserMenuPermissions',
    async (_, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.get(`/rolepermissions/menu/user`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch user menu permissions');
        }
    }
);

